/**
 * テキスト文字列中のhttp, https始まりの文字列をaタグのリンクに置き換える
 */
class AutoLinkUtil {
    static convert (text) {
      const paragraph = text.split(/(https?:\/\/[\w!?/+-_~=;.,*&@#$%()'[\]]+)/i)
      return paragraph.map(function (fragment, i) {
        if (i % 2) {
          return `<a href="${fragment}" target="_blank" rel="noopener noreferrer">${fragment}</a>`
        } else {
          return fragment
        }
      }).join('')
    }
  }
  
  export default AutoLinkUtil
  